import { MediaMatcher } from "@angular/cdk/layout";
import { ChangeDetectorRef, Component, Input, Output, EventEmitter } from "@angular/core";
import { MapHelperService } from "src/services/map-helper.service";
import { Observable, Subscription } from "rxjs";

import { environment } from "src/environments/environment";
import { PolygonDrawToolService } from "src/services/maps/features/PolygonDrawTool.service";
import { GeofencesMapService } from "../../../../services/GeofencesMap.service";
import { PanelAddGeofencesService } from "../../../../services/Panel-Add-Geofences.service";

@Component({
  selector: "buffer-selector",
  templateUrl: "./buffer-selector.component.html",
  styleUrls: ["./buffer-selector.component.css"],
})
export class BufferSelectorComponent {
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  isVisibleControlSliderRadio = false;
  $isVisibleControlSliderRadio : Observable<boolean> = new Observable<boolean>();


  @Input() fullScreen: boolean;
  @Input() initialRadio: string = "0.1";

  @Output() changedRadio = new EventEmitter<number>();

  bufferButtonMsg: string = "Selecciona un punto en el mapa para crear el centro del buffer, después modifique el radio del círculo";
  isBufferButtonMsgVisible: boolean = false;

  polygonDrawtoolCentroid: number[] = [];
  subscription_polygonDrawtoolCentroid: Subscription;
  
  subscription_GetSlider: Subscription;
  constructor(
    private panelAddGeofencesService: PanelAddGeofencesService,
    public mapHelperService: MapHelperService,
    public geofencesMapService: GeofencesMapService,
    private polygonDrawToolService: PolygonDrawToolService,
    changeDetectorRef: ChangeDetectorRef, 
    media: MediaMatcher) {
    this.mobileQuery = media.matchMedia("(min-width: 769px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    if(!environment.production) console.log("ngOnInit buffer-selector");
    this.subscription_GetSlider = this.panelAddGeofencesService.getVisibleControlSliderRadio().subscribe((data)=>{
      this.isVisibleControlSliderRadio = data;
    });

    this.subscription_polygonDrawtoolCentroid = this.polygonDrawToolService.getPolygonCentroid().subscribe((data)=>{
      console.log("polygon draw subject", data);
      if(data == null || data == undefined || data.length == 0 || (data[0] == 0 && data[1] == 0))
        return;
      
      this.polygonDrawtoolCentroid = data;
      this.geofencesMapService.bufferCenterLat = this.polygonDrawtoolCentroid[1];
      this.geofencesMapService.bufferCenterLng = this.polygonDrawtoolCentroid[0];
      this.geofencesMapService.UpdateActiveBuffer(
        this.geofencesMapService.bufferCenterLat,
        this.geofencesMapService.bufferCenterLng,
        this.geofencesMapService.bufferRadioKm
      );
      if(this.polygonDrawToolService.hasBufferDrawControl() && this.geofencesMapService.bufferFeature != null){
        this.polygonDrawToolService.drawGeofenceBuffer.deleteAll();
        this.polygonDrawToolService.drawGeofenceBuffer.add(this.geofencesMapService.bufferFeature);
      }
      if(!this.polygonDrawToolService.hasBufferDrawControl() && this.geofencesMapService.bufferFeature != null){
        this.polygonDrawToolService.addGeofenceBufferDrawControl();
        this.polygonDrawToolService.drawGeofenceBuffer.add(this.geofencesMapService.bufferFeature);
      }
    });

    this.loadBuffer();
  }

  ngOnDestroy(): void {
    if(!environment.production) console.log("ngOnDestroy buffer-selector");
    
    if (this.subscription_GetSlider)
      this.subscription_GetSlider.unsubscribe();

    if (this.subscription_polygonDrawtoolCentroid)
      this.subscription_polygonDrawtoolCentroid.unsubscribe();

    this.geofencesMapService.removeBufferDrawControl();

    this.panelAddGeofencesService.setVisibleControlSliderRadio(false);
    this.geofencesMapService.ResetActiveBuffer();
    // this.changedRadio.emit(0);
    this.polygonDrawToolService.removeGeofenceBufferDrawControl();
  }

  loadBuffer(){
    if(this.geofencesMapService.bufferFeature != null){
      this.geofencesMapService.UpdateActiveBuffer(
        this.geofencesMapService.bufferCenterLat,
        this.geofencesMapService.bufferCenterLng,
        this.geofencesMapService.bufferRadioKm
      );
      this.panelAddGeofencesService.setVisibleControlSliderRadio(true);

      if(!this.polygonDrawToolService.hasBufferDrawControl()){
        this.polygonDrawToolService.addGeofenceBufferDrawControl();
        this.polygonDrawToolService.drawGeofenceBuffer.add(this.geofencesMapService.bufferFeature);
      }
    }
  }

  onSetBufferCenter() {
    this.isBufferButtonMsgVisible = true;
    // this.mapHelperService.AddBufferGeofenceMode = true;
    // this.mapHelperService.AddPolygonGeofenceMode = false;
    // this.mapHelperService.toggleDrawControl();
    this.geofencesMapService.addBufferDrawControl();
    this.panelAddGeofencesService.setVisibleControlSliderRadio(true);
  }

  formatLabel(value: number) {
    if (value >= 1) {
      return value + "km";
    }
    return value;
  }

  onChangeRadio(event) {
    // this.mapHelperService.radioKm = event.value;
    this.geofencesMapService.bufferRadioKm = event.value;
    this.changedRadio.emit(event.value);
    var buffer = this.geofencesMapService.UpdateActiveBuffer(
      this.geofencesMapService.bufferCenterLat,
      this.geofencesMapService.bufferCenterLng,
      this.geofencesMapService.bufferRadioKm
    );

    this.polygonDrawToolService.addGeofenceBufferDrawControl();
    this.polygonDrawToolService.drawGeofenceBuffer.add(buffer);
  }

  onVisibilityChange(isVisible: boolean) {
    this.isBufferButtonMsgVisible = isVisible;
  }
}
